export const operatorsReducer = (state = {loading: true, resultOperator: null, operators: null, operatorsActives: [], operator: null } , action) => {
    switch (action.type) {
        case 'OPERATOR_GETALL_SUCCESS':
            return {
                ...state,
                loading: false,
                operators: action.payload.operators
            }
        case 'OPERATOR_GETACTIVE_SUCCESS':
            return {
                ...state,
                loading:false,
                operatorsActives: [...state.operatorsActives, action.payload.operators],
                resultOperator: action.payload.message
            }
        case 'OPERATOR_GET_SUCCESS':
            return {
                ...state,
                loading: false,
                operator: action.payload
            }
        case 'OPERATOR_ADD_SUCCESS':
            return {
                ...state,
                loading:false,
                operators: [...state.operators, action.payload.operator],
                resultOperator: action.payload.message
            }
        case 'OPERATOR_EDIT_SUCCESS':
            return {
                ...state,
                loading:false,
                operators: state.operators.map(operator => operator._id === action.payload.operator._id ? action.payload.operator : operator),
                resultOperator: action.payload.message
            }
        case 'OPERATOR_REMOVE_RESULT':
            if(action.payload.status === 261) {
                return {
                    ...state,
                    loading:false,
                    resultOperator: action.payload.message
                }
            } else {
                return {
                    ...state,
                    loading:false,
                    resultOperator: action.payload.message,
                    operators: state.operators.filter(operators => operators._id !== action.payload.operator)
                }
            }
        case 'OPERATOR_ENABLEDISABLE_SUCCESS':
            return {
                ...state,
                loading:false,
                operator: {...state.operator, active: action.payload.stateoperator},
                operators: state.operators.map(operator => operator._id === action.payload.idOperator ? {...operator, active: action.payload.stateoperator} : operator),
                resultuser: action.payload.message
            }
        case 'OPERATOR_RESET_RESULT':
            return {...state,
                resultOperator: null
            }
        case 'OPERATOR_LOADING':
            return {
                ...state,
                loading:true
            }
        case 'OPERATOR_NOT_LOADING':
            return {
                ...state,
                loading:false
            }
        case 'OPERATORS_RESET':
            return {
                ...state,
                operators: null
        }
        default:
            return state
    }
}

